module.exports = __webpack_public_path__ + "static/media/14.111.d254f0e9.jpg";